var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExternal28 = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.9621 7.30861C20.9377 7.24964 20.9015 7.19439 20.8536 7.14645C20.8056 7.09851 20.7504 7.06234 20.6914 7.03794C20.6324 7.01349 20.5678 7 20.5 7H20.4999H13.5C13.2239 7 13 7.22386 13 7.5C13 7.77614 13.2239 8 13.5 8H19.2929L7.14645 20.1464C6.95118 20.3417 6.95118 20.6583 7.14645 20.8536C7.34171 21.0488 7.65829 21.0488 7.85355 20.8536L20 8.70711V14.5C20 14.7761 20.2239 15 20.5 15C20.7761 15 21 14.7761 21 14.5V7.50049V7.5C21 7.499 21 7.498 21 7.497C20.9996 7.4303 20.9861 7.36669 20.9621 7.30861Z",
  fill: "#002D72"
})));
export { SvgExternal28 as ReactComponent };
export default __webpack_public_path__ + "1d4354f41f85b57219bf23f351d4f7ac.svg";